import axios from "axios";
import { toast } from 'react-toastify';


// const BASE_URL = 'https://cityrails-813c827db6cf.herokuapp.com/';

// const BASE_URL = 'http://localhost:4000/';

// const BASE_URL = 'https://louetta-nonincorporative-visually.ngrok-free.dev';

// const BASE_URL = 'http://192.168.1.33:4000';


// const BASE_URL = 'http://72.60.219.165/';

const BASE_URL = 'https://api.citycourierservices.in/';


const setupAPI = function () {
//   console.log('process.env.REACT_APP_STAGE', process.env.REACT_APP_STAGE);
//   switch (process.env.REACT_APP_STAGE) {
//     case 'production':
//       BASE_URL = 'https://rails-prod.voxprosoftware.com';
//       break;
//     case 'staging':
//       BASE_URL = 'https://uat-backend.voxprosoftware.com/';
//       break;
//     case 'development':
//       BASE_URL = 'http://localhost:3001';
//       break;
//     default:
//       BASE_URL = 'https://uat-backend.voxprosoftware.com/';
//       break;
//   }
};

setupAPI();

const fetchClient = () => {
  const defaultOptions = {
    baseURL: BASE_URL,
    // timeout: 20000,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      
    }
  };

  // Create instance
  const instance = axios.create(defaultOptions);

  instance.interceptors.response.use(
    function  (successRes) {
      toast.dismiss();
      return successRes;
    },
    function (error) {
      const status = error?.response?.status;
      const requestUrl = error?.config?.url || '';
      const isAdminDetailRequest = requestUrl.includes('/api/v1/admin_detail');

      if (status === 401) {
        // Wrong current password for profile update can return 401.
        // Let page-level catch handle it without forcing logout.
        if (!isAdminDetailRequest) {
          toast.error(error?.response?.data?.message || 'Unauthorized');
          setTimeout(() => {
            window.location.href = "/login";
          }, 2000);
        }




      }

      console.log(error)

      return Promise.reject(error);
    }
  );

  // Set the AUTH token for any request
  instance.interceptors.request.use(function (config) {
    const isLoggedIn = JSON.parse(localStorage.getItem('user')) ? true : false;
    const token = localStorage.getItem('token');
    if (isLoggedIn && !config.url.includes("s3.amazonaws.com")) {
      config.headers.Authorization = token ? `Bearer ${token}` : `Bearer ''`;
      config.headers.adminId=localStorage.getItem('adminId')
    }

    return config;
  });

  return instance;
};

export default fetchClient();
